<lib-shared-notification-popup className="error"
                               [dialogRef]="dialogRef"
                               [dialogTitle]="title"
                               [message]="message"
                               [showCloseButton]="allowClose"
                               notificationButtonLabel="Close"
                               i18n-notificationButtonLabel="@@communication-centre.error-popup.button.close">
</lib-shared-notification-popup>
